import {
  CF_ALL_ACCESS_MONTHLY_PRICE_USD,
  CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
  CF_ALL_ACCESS_YEARLY_PRICE,
  CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
  CF_ALL_ACCESS_YEARLY_WORTH_VALUE,
  CF_STUDIO_AI_YEARLY_PROMO_PRICE,
} from 'constants/prices'

export const formatPrice = (price: number) => {
  return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export type Variant =
  | 'freeTrial'
  | 'yearly'
  | 'yearlyPromo'
  | 'monthly'
  | 'freeTrialYearly'
  | 'freeTrialAiStudio'
  | 'aiStudio'

export type MapKey =
  | Variant
  | `${Extract<Variant, 'freeTrial'>}_usd`
  | `${Extract<Variant, 'monthly'>}_usd`

export const productIdMap: Record<MapKey, number | string> = {
  freeTrial: 246_178,
  freeTrial_usd: 246_178,
  yearly: 3_677_237,
  yearlyPromo: 3_677_237,
  monthly: 246_178,
  monthly_usd: 246_178,
  freeTrialYearly: 60_189_699,
  freeTrialAiStudio: 'studio_ai_yearly_free_trial',
  aiStudio: 'studio_ai_yearly',
}

export const subtotalMap: Record<MapKey, number> = {
  freeTrial: CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
  freeTrial_usd: CF_ALL_ACCESS_MONTHLY_PRICE_USD,
  yearly: CF_ALL_ACCESS_YEARLY_WORTH_VALUE,
  yearlyPromo: CF_ALL_ACCESS_YEARLY_WORTH_VALUE,
  monthly: CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
  monthly_usd: CF_ALL_ACCESS_MONTHLY_PRICE_USD,
  freeTrialYearly: CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
  freeTrialAiStudio: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
  aiStudio: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
}

export const savingMap: Record<MapKey, number> = {
  freeTrial: CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
  freeTrial_usd: CF_ALL_ACCESS_MONTHLY_PRICE_USD,
  yearly: 288.12,
  yearlyPromo: 301,
  monthly: 0,
  monthly_usd: 0,
  freeTrialYearly: CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
  freeTrialAiStudio: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
  aiStudio: 0,
}

export const promoMap: Record<MapKey, string> = {
  freeTrial: 'fxvpybdw',
  freeTrial_usd: 'fxvpybdw',
  yearly: 'allaccessspecialevent',
  yearlyPromo: 'allaccessspecialdeal',
  monthly: '',
  monthly_usd: '',
  freeTrialYearly: 'fxvpybdw',
  freeTrialAiStudio: 'fxvpybdw',
  aiStudio: '',
}

export const totalMap: Record<MapKey, number> = {
  freeTrial: 0,
  freeTrial_usd: 0,
  yearly: CF_ALL_ACCESS_YEARLY_PRICE,
  yearlyPromo: CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
  monthly: CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
  monthly_usd: CF_ALL_ACCESS_MONTHLY_PRICE_USD,
  freeTrialYearly: 0,
  freeTrialAiStudio: 0,
  aiStudio: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
}
